const Index = () => import("./index.vue");
const CreatePage = () => import("./_pages/create.vue");
const ViewPage = () => import("./_pages/view.vue");

export default [
  {
    path: "/sale-types",
    component: Index,
  },
  {
    path: "/new-sale-type",
    component: CreatePage,
  },
  {
    path: "/sale-type/:id",
    component: ViewPage,
  },
];
